import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
    selector: 'page-register-confirmation',
    templateUrl: 'register-confirmation.html'
})
export class RegisterConfirmationPage {

    constructor(
        public analytics: FirebaseAnalytics,
        public navCtrl: NavController,
    ) {

    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('RegisterConfirmation');
    }

    /**
     * goToLogin
     */
    public goToLogin() {
        this.navCtrl.setRoot(LoginPage, {}, {
            animate: true,
            direction: 'forward',
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/register-confirmation/register-confirmation.ts